var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "app-divider",
        { attrs: { label: "Dados do VTN", showBorder: true } },
        [
          _c(
            "template",
            { slot: "actionButton" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.exportarPdf()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fal fa-file-pdf" }),
                  _c("span", [_vm._v("  Exportar PDF")])
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Processo Nº:  ")]),
            _c("span", [
              _vm._v(_vm._s(_vm.dadosVtn.processoFisico.numero || "-"))
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Município:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.dadosVtn.processoFisico.endereco.municipio.nome || "-"
                )
              )
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Região:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.dadosVtn.processoFisico.endereco.municipio.regiao || "-"
                )
              )
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("Sr - Área requerida:  ")
            ]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.formatarNumero(_vm.dadosVtn.areaRequerida, 4)) +
                  " ha"
              )
            ])
          ])
        ],
        1
      ),
      _c("app-divider", {
        attrs: { label: "IFa - Distância", showBorder: true }
      }),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("Fator de distância:  ")
            ]),
            _c("span", [_vm._v(_vm._s(_vm.dadosVtn.fatorDistancia.descricao))])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Índice:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("formatDouble")(_vm.dadosVtn.fatorDistancia.indice)
                )
              )
            ])
          ])
        ],
        1
      ),
      _c("app-divider", {
        attrs: { label: "IFb - Acesso à área", showBorder: true }
      }),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("Fator de acesso:  ")
            ]),
            _c("span", [_vm._v(_vm._s(_vm.dadosVtn.fatorAcesso.descricao))])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Índice:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(_vm._f("formatDouble")(_vm.dadosVtn.fatorAcesso.indice))
              )
            ])
          ])
        ],
        1
      ),
      _c("app-divider", {
        attrs: { label: "IFc - Ancianidade da ocupação", showBorder: true }
      }),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("Fator de tempo de ocupação:  ")
            ]),
            _c("span", [
              _vm._v(_vm._s(_vm.dadosVtn.fatorTempoOcupacao.descricao))
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Índice:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("formatDouble")(_vm.dadosVtn.fatorTempoOcupacao.indice)
                )
              )
            ])
          ])
        ],
        1
      ),
      _c("app-divider", {
        attrs: { label: "IFd - Dimensão da área", showBorder: true }
      }),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.estado == "pa" ? "VRD" : "VRT") + ":  ")
            ]),
            _c("span", [
              _vm._v(
                "R$ " +
                  _vm._s(
                    _vm._f("formatDouble")(_vm.dadosVtn.calculosVtn.valorRegiao)
                  )
              )
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("MF:  ")]),
            _c("span", [_vm._v(_vm._s(_vm.dadosVtn.calculosVtn.mf) + " ha")])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("VTN/ha:  ")]),
            _c("span", [
              _vm._v(
                "R$ " +
                  _vm._s(_vm._f("formatDouble")(_vm.dadosVtn.calculosVtn.vrt))
              )
            ])
          ]),
          _vm.estado != "pa"
            ? _c("el-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "label" }, [_vm._v("Índice:  ")]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDouble")(
                        _vm.dadosVtn.calculosVtn.indiceArea
                      )
                    )
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Nº de MF:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("formatDouble")(_vm.dadosVtn.calculosVtn.numeroMf)
                )
              )
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("VTN:  ")]),
            _c("span", [
              _vm._v(
                "R$ " +
                  _vm._s(_vm._f("formatDouble")(_vm.dadosVtn.calculosVtn.vtn))
              )
            ])
          ])
        ],
        1
      ),
      _c("app-divider", {
        attrs: { label: "Taxa de ocupação", showBorder: true }
      }),
      _c(
        "el-row",
        { staticClass: "rowResumo" },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("Taxa de ocupação (ano):  ")
            ]),
            _c("span", [_vm._v(_vm._s(_vm.dadosVtn.tempoOcupacao))])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Porcentagem:  ")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("formatDouble")(
                    _vm.dadosVtn.calculosVtn.taxaOcupacaoPorcentagem
                  )
                ) + " %"
              )
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Valor da taxa:  ")]),
            _c("span", [
              _vm._v(
                "R$ " +
                  _vm._s(
                    _vm._f("formatDouble")(
                      _vm.dadosVtn.calculosVtn.valorTaxaOcupacao
                    )
                  )
              )
            ])
          ])
        ],
        1
      ),
      _vm.dadosVtn.calculosVtn.resumoCustasProcessuais
        ? _c(
            "div",
            [
              _c("app-divider", {
                attrs: { label: "Custas processuais", showBorder: true }
              }),
              _c(
                "div",
                { staticClass: "px-10" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.dadosVtn.calculosVtn.resumoCustasProcessuais
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Discriminação",
                          prop: "descricao",
                          "min-width": "500"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasProcessuais.length -
                                            1
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.descricao))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          803472712
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Quantidade",
                          prop: "quantidade",
                          "min-width": "150"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasProcessuais.length -
                                            1
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.quantidade))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3662298397
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Valor (R$)",
                          prop: "valor",
                          "min-width": "250",
                          align: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasProcessuais.length -
                                            1
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDouble")(
                                            scope.row.valor
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2790153446
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Quantidade em UPFPA",
                          prop: "quantidadeUPFPA",
                          "min-width": "250",
                          align: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasProcessuais.length -
                                            1
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDouble")(
                                            scope.row.quantidadeUPFPA
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3460624896
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.dadosVtn.calculosVtn.resumoCustasAgrarias
        ? _c(
            "div",
            [
              _c("app-divider", {
                attrs: { label: "Custas agrárias", showBorder: true }
              }),
              _c(
                "div",
                { staticClass: "px-10" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.dadosVtn.calculosVtn.resumoCustasAgrarias
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Discriminação",
                          prop: "descricao",
                          "min-width": "500"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasAgrarias.length -
                                            1
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.descricao))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1223014961
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Quantidade",
                          prop: "quantidade",
                          "min-width": "150"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasAgrarias.length -
                                            1
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.quantidade))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4116424516
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Valor",
                          prop: "valor",
                          "min-width": "250",
                          align: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasAgrarias.length -
                                            1
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "R$ " +
                                          _vm._s(
                                            _vm._f("formatDouble")(
                                              scope.row.valor
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          940024066
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Quantidade em UPFPA",
                          prop: "quantidadeUPFPA",
                          "min-width": "250",
                          align: "right"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        label:
                                          scope.$index ===
                                          _vm.dadosVtn.calculosVtn
                                            .resumoCustasAgrarias.length -
                                            1
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDouble")(
                                            scope.row.quantidadeUPFPA
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          242954873
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("app-divider", {
        staticClass: "mt-3",
        attrs: { label: "Dados do pagamento", showBorder: true }
      }),
      _c("div", { staticClass: "pad-10" }, [
        _c("b", [_vm._v("Observações:  ")]),
        _c("ul", [
          _c("li", [_vm._v(_vm._s(_vm.msgCalculo()))]),
          _c("li", [_vm._v(_vm._s(_vm.msgReajuste()))]),
          _vm.dadosVtn.respeitaLegislacaoAmbiental
            ? _c("li", [
                _c("span", [
                  _vm._v(
                    "Respeita a legislação ambiental, preservando originariamente a reserva legal nos índices legalmente previstos e conservando a área de preservação permanente, com a devida apresentação pelo interessado da comprovação\n emitida pelo órgão ambiental (desconto de 30%)."
                  )
                ])
              ])
            : _vm._e(),
          _vm.dadosVtn.temDireitoRegularizacao
            ? _c("li", [
                _c("span", [
                  _vm._v(
                    "Tem direito a regularização fundiária através do regime especial de compra (desconto de 20%)."
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _c(
        "div",
        { staticClass: "px-10" },
        [
          _vm.dadosVtn &&
          _vm.dadosVtn.calculosVtn &&
          _vm.dadosVtn.calculosVtn.resumoVtn
            ? _c(
                "el-table",
                {
                  staticClass: "mt-3",
                  attrs: { data: _vm.dadosVtn.calculosVtn.resumoVtn }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Resumo", prop: "descricao" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtn
                                        .length -
                                        1
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                              ),
                              scope.row.descricao === "Custas agrárias"
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.msgAgrarias,
                                        placement: "right"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-question-circle"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1207019573
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Valor", prop: "valor", align: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtn
                                        .length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4219283569
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Quantidade em UPFPA",
                      prop: "quantidadeUPFPA",
                      align: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtn
                                        .length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDouble")(
                                        scope.row.quantidadeUPFPA
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2289047466
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "px-10" },
        [
          _vm.dadosVtn.calculosVtn.resumoVtnComDesconto
            ? _c(
                "el-table",
                {
                  staticClass: "mt-3",
                  attrs: { data: _vm.dadosVtn.calculosVtn.resumoVtnComDesconto }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Resumo com desconto", prop: "descricao" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn
                                        .resumoVtnComDesconto.length -
                                        1
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                              ),
                              scope.row.descricao === "Custas agrárias"
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.msgAgrarias,
                                        placement: "right"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-question-circle"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1289007711
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Valor", prop: "valor", align: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn
                                        .resumoVtnComDesconto.length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3117634107
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Quantidade em UPFPA",
                      prop: "quantidadeUPFPA",
                      align: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn
                                        .resumoVtnComDesconto.length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDouble")(
                                        scope.row.quantidadeUPFPA
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2140224448
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "px-10" },
        [
          _vm.dadosVtn.formaPagamento === "PARCELADO"
            ? _c(
                "el-table",
                {
                  staticClass: "mt-3",
                  attrs: { data: _vm.dadosVtn.calculosVtn.resumoVtnParcelas }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "Detalhamento das parcelas",
                      prop: "descricao"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                        .length -
                                        1
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                              ),
                              scope.row.descricao === "Custas agrárias"
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.msgAgrarias,
                                        placement: "right"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-question-circle"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1151513501
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Valor (R$)", prop: "valor" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                        .length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      766186154
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Quantidade em UPFPA",
                      prop: "quantidadeUPFPA"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    label:
                                      scope.$index ===
                                      _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                        .length -
                                        1
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDouble")(
                                        scope.row.quantidadeUPFPA
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      122413617
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36925718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36925718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/vtn/ResumoVtn.vue
// module id = null
// module chunks = 